import React from 'react';
import '../../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-container">
        {/* Column 1: About College */}
        <div className="footer-column">
          <h3>SHRI MULIKADEVI MAHAVIDYALAYA</h3>
          <p>
            Nighoj, Taluka Parner, District Ahmednagar, Maharashtra – 414306
          </p>
          <p>📞 +91 9876543210</p>
          <p>📧 info@shrimulikadevicollege.com</p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/courses">Courses</a></li>
            <li><a href="/gallery">Gallery</a></li>
            <li><a href="/placements">Placements</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>

        {/* Column 3: Map Button */}
        <div className="footer-column map-column">
          <h4>Find Us</h4>
          <div className="map-preview">
            <p>📍 Click below to view our location on Google Maps:</p>
            <div className="map-pin-icon">📍</div>
            <a
              href="https://www.google.com/maps?ll=18.966507,74.292872&z=12&t=m&hl=en&gl=IN&mapclient=embed&cid=12749276666324937883" // Replace with your real college location link
              target="_blank"
              rel="noopener noreferrer"
              className="map-button"
            >
              Open in Google Maps
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© 2026 Shri Mulikadevi Mahavidyalaya, Nighoj. All rights reserved.</p>
        <p className="designed-by">Designed & Managed by <span>Team Tech Voyagers</span></p>
      </div>
    </footer>
  );
};

export default Footer;
